import type { TFunction } from "i18next";

import type { ModuleOverview } from "@/domains/certifications/types";
import { getModuleVideoMeta } from "@/domains/certifications/utils";
import { MODULE_STATUSES } from "@/domains/certifications/constants";

export const getCommunityRequirement = (
  t: TFunction,
  weeks: ModuleOverview[],
) => {
  const asksForCommunity = (week: ModuleOverview) =>
    (week.posts?.target ?? 0) > 0 || (week.comments?.target ?? 0) > 0;
  const week =
    weeks.find(
      (item) =>
        item.status === MODULE_STATUSES.CURRENT && asksForCommunity(item),
    ) ?? weeks.find(asksForCommunity);
  if (!week) {
    return null;
  }

  const posts = week.posts?.target ?? 0;
  const comments = week.comments?.target ?? 0;
  const postsText = t("certification.overview.communityPosts", {
    count: posts,
  });
  const commentsText = t("certification.overview.communityComments", {
    count: comments,
  });
  if (posts > 0 && comments > 0) {
    return t("certification.overview.communityBoth", {
      posts: postsText,
      comments: commentsText,
    });
  }
  return posts > 0 ? postsText : commentsText;
};

export const getCompletedWeekMeta = (t: TFunction, week: ModuleOverview) => {
  const parts = [getModuleVideoMeta(t, week.module)];
  if (week.knowledgeCheck?.isPassed) {
    parts.push(t("certification.overview.checkPassed"));
  }
  if (week.posts || week.comments) {
    const contributions =
      (week.posts?.current ?? 0) + (week.comments?.current ?? 0);
    parts.push(
      t("certification.overview.contributionCount", { count: contributions }),
    );
  }
  return parts.join(" · ");
};
